import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import PinInput from 'react-pin-input';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeModal } from '../../redux/actions';
import { abortValidation, sendValidation } from '../../redux/actions/ticket';
import { Button } from '../../components';

import { StaffContainer, StaffHeading, StaffDescription, StaffMessage, StaffButtonContainer } from './styles';

const StaffValidate = ({ validationStatus, handleCodeSubmit, onCancelValidationClick, isTablet, onCloseModalClick, bookingId, validationMessage }) => {
  const [code, handlePinInput] = useState('');

  const renderButtons = () => {
    switch (validationStatus) {
      case 'input':
      case 'fetching':
        return (
          <Fragment>
            <Button htmlType="button" theme="secondary" onClick={isTablet ? onCancelValidationClick: () => { onCancelValidationClick(); onCloseModalClick(); }}>Cancel</Button>
            <Button htmlType="button" theme="primary" onClick={() => handleCodeSubmit(code, bookingId)}>Staff Validate</Button>
          </Fragment>
        );
      case 'failure':
        return (
          <Fragment>
            <Button htmlType="button" theme="secondary" onClick={isTablet ? onCancelValidationClick: () => { onCancelValidationClick(); onCloseModalClick(); }}>Cancel</Button>
            <Button htmlType="button" theme="primary" onClick={() => handleCodeSubmit(code, bookingId)}>Try Again</Button>
          </Fragment>
        );
      case 'success':
        return <Button htmlType="button" theme="primary" onClick={isTablet ? onCancelValidationClick: () => { onCancelValidationClick(); onCloseModalClick(); }}>Done</Button>;
      default:
        return null;
    }
  };

  return (
    <StaffContainer>
      <StaffHeading>Validation</StaffHeading>
      <StaffDescription>Staff, please enter validation code provided to you by DayAxe.</StaffDescription>
      <PinInput
        length={4}
        type="numeric"
        secret={false}
        pattern="[0-9]"
        onComplete={pin => handlePinInput(pin)}
        inputStyle={{ border: 'none', borderBottom: '1px solid #32befe', width: 40, margin: '0 5px', fontWeight: 700, fontSize: 35, color: '#32befe' }}
      />
      {validationStatus === 'success' && <StaffMessage status="success">Success! This ticket is valid! You may issue this customer an access card.</StaffMessage>}
      {validationStatus === 'failure' && <StaffMessage status="failure">{validationMessage}</StaffMessage>}
      <StaffButtonContainer>
        {renderButtons()}
      </StaffButtonContainer>
    </StaffContainer>
  );
};

StaffValidate.propTypes = {
  validationStatus: PropTypes.string,
  handleCodeSubmit: PropTypes.func,
  onCancelValidationClick: PropTypes.func,
  isTablet: PropTypes.bool,
  onCloseModalClick: PropTypes.func,
  bookingId: PropTypes.number,
  validationMessage: PropTypes.string,
};

const mapStateToProps = state => ({
  validationStatus: state.validation.status,
  validationMessage: state.validation.message,
  bookingId: state.bookingManagement.hotel.bookingId,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleCodeSubmit: sendValidation,
  onCancelValidationClick: abortValidation,
  onCloseModalClick: closeModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StaffValidate);
